import React from 'react';
import { useAuth } from '../contexts/AuthContext';
import Home from '../pages/Home';
import PlayerHomepage from '../pages/player/Homepage';

/**
 * Route component that shows player homepage for logged-in users,
 * or public home page for logged-out users
 */
export default function HomeRoute() {
  const { currentUser, loading } = useAuth();

  // Show loading state while checking auth
  if (loading) {
    return (
      <div className="min-h-screen bg-gray-50 flex items-center justify-center">
        <div className="text-center">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-survivor-600 mx-auto"></div>
        </div>
      </div>
    );
  }

  // Show player homepage if logged in, otherwise show public home
  return currentUser ? <PlayerHomepage /> : <Home />;
}

